import * as React from "react";

function PersonButton({ person, small } = {}) {
  return (
    <span
      className={`person-button ${
        small ? "person-button-sm" : ""
      } rounded-5 border-1 text-truncate px-2 justify-content-center d-inline-flex flex-column me-1`}
    >
      {small ? <span className="small">{person.name}</span> : person.name}
    </span>
  );
}

export default PersonButton;
